import React from "react";
import {Button} from "@mui/material";
import { Dialog } from "@progress/kendo-react-dialogs";
import "./ConfirmationDialog.scss";

const ConfirmationDialog = (props) => {
  const className = props.className
    ? `${props.className} instream-confirmation-dialog`
    : "instream-confirmation-dialog";

  return (
    <Dialog
      className={className}
      title={props.title}
      onClose={props.onClose ? props.onClose : props.onCancel}
    >
      <p>{props.message}</p>
      <div className={"instream-dialog-buttons"}>
        {!props.hideCancel &&
          <Button
            color={"secondary"}
            variant={"contained"}
            onClick={props.onCancel}
            className={"k-secondary"}
          >
            {props.cancelLabel}
          </Button>
        }
        <Button
          color={"primary"}
          variant={"contained"}
          onClick={props.onConfirm}
        >
          {props.confirmLabel}
        </Button>
      </div>
    </Dialog>
  );
};

export default ConfirmationDialog;
